<template>
  <v-card flat class="mt-2">
    <v-slide-y-transition>
      <v-card-title v-if="showGridFilter">
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field append-icon="filter_list" :label="messages.label.ASSET_FILTER" single-line hide-details
              v-model="search" @input="value => filterSearchResult(value)">
            </v-text-field>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <v-btn-toggle v-model="linkedToggle" @click.native="toggleLinked()">
              <v-btn value="All">
                All
              </v-btn>
              <v-btn value="UnLinked">
                Un-linked
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-slide-y-transition>
    <v-card-text class="py-1">
      <v-data-table :headers="headers" :items="filteredSearchResult" :pagination.sync="pagination"
        :total-items="totalItems" :loading="offersLoading" :rows-per-page-items="rowsPerPagesArray">
        <!-- Items -->
        <template slot="items" slot-scope="props">
          <tr :class="{ 'light-green lighten-3 black--text': isRecordOperatedNow(props.item) }">
            <td>
              <v-btn fab dark small dense color="primary" :disabled="offersLoading" @click="editOffer(props.item)">
                <v-icon dark v-if="props.item.assetReference">edit</v-icon>
                <v-icon dark v-else>link</v-icon>
              </v-btn>
            </td>
            <td class="text-xs-left">{{ props.item.assetReference | assetReferenceDisplay }}</td>
            <td class="text-xs-left">{{ props.item.title }}</td>
            <td class="text-xs-left">{{ props.item.offerFormat }}</td>
            <td class="text-xs-left">{{ props.item.offerType }}</td>
            <td class="text-xs-left">{{ props.item.price }}</td>
            <td class="text-xs-left">{{ props.item.rightsWindowStart }}</td>
            <td class="text-xs-left">{{ props.item.rightsWindowEnd }}</td>
            <td class="text-xs-left">{{ props.item.providerName }}</td>
            <td class="text-xs-left">{{ props.item.affiliate }}</td>
            <td class="text-xs-left">{{ props.item._tags }}</td>
          </tr>
        </template>
        <!-- No Data -->
        <template slot="no-data">
          <v-alert :value="true" :color="initiatedSearch ? 'error' : 'info'"
            :class="{ 'black--text': !initiatedSearch, 'white--text': initiatedSearch }"
            :icon="!initiatedSearch ? 'info' : 'warning'">
            <span v-if="!initiatedSearch">
              {{ messages.info.SELECT_SEARCH_CRITERIA }}
            </span>
            <span v-else>
              {{ messages.info.NO_SEARCH_RESULTS }}
            </span>
          </v-alert>
        </template>
        <!-- No Results -->
        <template slot="no-results">
          <v-alert :value="true" color="info" class="black--text" icon="warning">
            {{ messages.info.NO_FILTER_RESULTS }}
          </v-alert>
        </template>
        <!-- Page Text -->
        <template slot="pageText" slot-scope="props">
          {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
        </template>
      </v-data-table>
      <v-snackbar :timeout="snackbar.timeout" :top="true" color="light-green black--text" v-model="snackbar.show">
        {{ snackbar.message }}
        <v-btn flat color="primary" @click.native="snackbar.show = false">Ok</v-btn>
      </v-snackbar>
    </v-card-text>
    <!-- Offers Edit Dialog -->
    <OffersEdit />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex"
import PreIngestService from "@/PreIngest/PreIngestService"
import * as preIngestDataService from "@/PreIngest/PreIngestDataService"
import OffersEdit from "@/PreIngest/Offers/OffersEdit"
import messages from "@/PreIngest/messages.json"
import AppService from "@/AppService"
import {
  VOD_SYCN_OFFERING_WEB_SERVICE_URL
} from "@/store/constants/getter-types"
import * as utils from "@/Shared/utils"

export default {
  name: "OffersSearchResult",
  components: {
    OffersEdit
  },
  data() {
    return {
      search: "",
      offersLoading: false,
      initiatedSearch: false,
      pagination: {
        sortBy: "",
        page: 1,
        rowsPerPage: 25,
        descending: false
      },
      snackbar: {
        show: false,
        message: "",
        timeout: 6000
      },
      totalItems: 0,
      rowsPerPagesArray: [25, 50, 75, 100],
      headers: this.getTableHeaders(),
      searchResult: [],
      filteredSearchResult: [],
      searchObject: {},
      linkedToggle: "All"
    }
  },
  computed: {
    ...mapGetters([
      VOD_SYCN_OFFERING_WEB_SERVICE_URL
    ]),
    showGridFilter() {
      return this.searchResult.length > 0
    }
  },
  watch: {
    /**
     * Watch handler for pagination object
     */
    pagination: {
      handler(newVal, oldVal) {
        if (this.initiatedSearch && oldVal.page !== newVal.page) {
          this.searchOffers()
        }
      },
      deep: true
    }
  },
  methods: {
    /**
     * For filtering search result with text value
     */
    filterSearchResult(search) {
      if (search) {
        search = search.toString().toLowerCase()
        const displayedKeys = [
          "assetReference",
          "title",
          "offerFormat",
          "offerType",
          "price",
          "metadataVersion",
          "rightsWindowStart",
          "rightsWindowEnd",
          "providerName",
          "affiliate",
          "_tags"
        ]
        this.filteredSearchResult = this.searchResult.filter((obj) => {
          let filteredObj = this.$lodash.pick(obj, displayedKeys)
          return Object.keys(filteredObj).some(function (key) {
            if (filteredObj[key] !== null) {
              return filteredObj[key]
                .toString()
                .toLowerCase()
                .includes(search)
            }
          })
        })
      } else {
        this.filteredSearchResult = this.searchResult
      }
    },

    /**
     * toggleLinked - toggle between linked / un-linked offers
     */
    toggleLinked() {
      // All / Unlinked toggle
      switch (this.linkedToggle) {
        case "All":
          this.filterSearchResult(this.search)
          break
        case "UnLinked":
          this.filteredSearchResult = this.$lodash.filter(
            this.filteredSearchResult,
            (obj) => {
              return obj.assetReference === null
            }
          )
          break
      }
    },

    /**
     * Get pagination params
     */
    getPageParams(pagination) {
      let startRange
      let endRange
      if (pagination.page === 1) {
        startRange = 1
        endRange = pagination.rowsPerPage
      } else {
        startRange = (pagination.page - 1) * pagination.rowsPerPage + 1
        endRange = startRange + pagination.rowsPerPage - 1
      }
      return startRange + "-" + endRange
    },

    /**
     * getSortParams - Construct sorting param
     *
     * @param  {object} pagination pagination object
     * @return {string}            ex: '<filedName>|desc'
     */
    getSortParams(pagination) {
      let sortParams = ""
      sortParams =
        !this.$lodash.isNull(pagination.sortBy) &&
          !this.$lodash.isEmpty(pagination.sortBy)
          ? pagination.sortBy
          : "added|desc"
      if (pagination.descending) {
        sortParams += "|desc"
      }
      return sortParams
    },

    /**
     * searchOffers - construct request object and begin to search offers
     */
    searchOffers(reason) {
      let editedRecordIds = []
      if (!this.$lodash.isUndefined(reason)) {
        // Search is triggered due to editing
        if (reason.edit) {
          editedRecordIds.push(reason.editedRecordId)
          this.searchObject.sort = "updated|desc"
          this.pagination.descending = true
          this.pagination.sortBy = "updated"
          this.pagination.page = 1
        }
      }
      this.searchObject.sort = "updated|desc"
      this.searchObject.range = this.getPageParams(this.pagination)
      this.searchObject.sort = this.getSortParams(this.pagination)
      this.searchObject.count = true
      this.retrieveOffers().then((searchResult) => {
        if (!this.$lodash.isEmpty(editedRecordIds)) {
          // Mark records so that they can be identified as edited records
          this.searchResult = this.markRecords(searchResult, editedRecordIds)
          this.snackbar.message = this.messages.info.EDITED_OFFERS
          this.snackbar.show = true
        } else {
          this.searchResult = searchResult
        }
      })
    },

    /**
     * markRecords - mark records so that they can be visually highlighted
     *
     * @param  {array} searchResult list of offers from search
     * @param  {array} recordIds    record Ids which need to be marked
     * @return {array}              search result with marked records
     */
    markRecords(searchResult, recordIds) {
      // Mark records with '_operatedNow' property to highlight them in data grid
      let operatedRecordNumbers = this.$lodash.map(recordIds, (recordId) => {
        return this.$lodash.last(recordId.split("/"))
      })
      this.$lodash.forEach(searchResult, (offerRecord) => {
        let index = this.$lodash.findIndex(
          operatedRecordNumbers,
          (operatedRecordNumber) => {
            let recordNumber = this.$lodash.last(offerRecord.id.split("/"))
            return operatedRecordNumber === recordNumber
          }
        )
        if (index > -1) {
          offerRecord._operatedNow = true
        } else {
          offerRecord._operatedNow = false
        }
      })
      return searchResult
    },

    /**
     * isRecordOperatedNow - Check if the record is edited in current session
     *
     * @param  {object} offerRecord offer object
     * @return {boolean}
     */
    isRecordOperatedNow(offerRecord) {
      return offerRecord._operatedNow
    },

    /**
     * retrieveOffers - Retrieve offers from service
     * @return {Promise}  search promise
     */
    retrieveOffers() {
      this.offersLoading = true
      preIngestDataService.retrieveAssetOffers(this.searchObject,
        this.VOD_SYCN_OFFERING_WEB_SERVICE_URL)
        .then((response) => {
          if (!this.$lodash.isUndefined(response.data.entries)) {
            this.searchResult = response.data.entries
            this.massageData()
            this.filterSearchResult(this.search)
            this.totalItems = response.data.totalResults
          } else {
            this.searchResult = []
          }
          this.offersLoading = false
          this.initiatedSearch = true
          return this.searchResult
        })
        .catch((error) => {
          this.searchResult = []
          this.filteredSearchResult = []
          this.totalItems = 0
          this.offersLoading = false
          this.initiatedSearch = true
          return Promise.reject(error)
        })
    },

    /**
     * massageData - converting added and updated unix time stamp to local date time string
     */
    massageData() {
      let recordObject
      for (var item in this.searchResult) {
        recordObject = this.searchResult[item]
        // Format datetime value
        recordObject._updated = !this.$lodash.isNull(recordObject.updated)
          ? this.getLocalDateTime(recordObject.updated)
          : ""
        recordObject._added = !this.$lodash.isNull(recordObject.added)
          ? this.getLocalDateTime(recordObject.added)
          : ""
        // Convert tags array to string
        if (recordObject.offerTags.length > 0) {
          recordObject._tags = recordObject.offerTags.join(",")
        } else {
          recordObject._tags = ""
        }
      }
    },

    /**
     * getTableHeaders - Construct array of objects to show table headers
     *
     * @return {array}
     */
    getTableHeaders() {
      let headers = [
        {
          text: "",
          sortable: false
        },
        {
          text: messages.label.TH_PACKAGE_ID,
          align: "left",
          sortable: false,
          value: "assetReference"
        },
        {
          text: messages.label.TH_TITLE,
          align: "left",
          value: "title"
        },
        {
          text: messages.label.TH_FORMAT,
          align: "left",
          sortable: false,
          value: "offerFormat"
        },
        {
          text: messages.label.TH_TYPE,
          align: "left",
          sortable: false,
          value: "offerType"
        },
        {
          text: messages.label.TH_PRICE,
          align: "left",
          sortable: false,
          value: "price"
        },
        {
          text: messages.label.TH_START,
          align: "left",
          value: "rightsWindowStart",
          sortable: false
        },
        {
          text: messages.label.TH_END,
          align: "left",
          value: "rightsWindowEnd",
          sortable: false
        },
        {
          text: messages.label.TH_PROVIDER,
          align: "left",
          value: "providerName",
          sortable: false
        },
        {
          text: messages.label.TH_AFFILIATE,
          align: "left",
          value: "affiliate",
          sortable: false
        },
        {
          text: messages.label.TH_TAGS,
          align: "left",
          value: "offerTags",
          sortable: false
        }
      ]

      return headers
    },

    /**
     * getLocalDateTime - Retrieve local time
     *
     * @param  {Number} dateTime unix time stamp
     * @return {string}          date time in local
     */
    getLocalDateTime(dateTime) {
      return utils.getLocalDateTime(dateTime)
    },

    /**
     * editOffer - description
     *
     * @return {type}  description
     */
    editOffer(offer) {
      AppService.$emit("event:EditOffer", offer)
    }
  },
  filters: {
    /**
     * assetReferenceDisplay - return string '---' if asset reference is null
     *
     * @param  {string} value asset reference
     * @return {string}
     */
    assetReferenceDisplay(value) {
      if (!value) {
        return "---"
      } else {
        return value
      }
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages

    /**
     * Events
     */
    PreIngestService.$on("event:searchOffers", (searchParams) => {
      this.searchObject = searchParams
      this.searchOffers()
    })
    PreIngestService.$on("event:refreshOffers", (reason) => {
      this.searchOffers(reason)
    })
  },
  beforeDestroy() {
    PreIngestService.$off("event:searchOffers")
    PreIngestService.$off("event:refreshOffers")
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/PreIngest/Offers/OffersSearchResult.vue